import { render } from "./CguView.vue?vue&type=template&id=1d420b32&scoped=true"
import script from "./CguView.vue?vue&type=script&lang=js"
export * from "./CguView.vue?vue&type=script&lang=js"

import "./CguView.vue?vue&type=style&index=0&id=1d420b32&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d420b32"]])

export default __exports__